import React from 'react'
import ReactMarkdown from 'react-markdown'

import { linkifyMarkdown } from "../../../lib/Tools"
import ItemTemplate from './ItemTemplate'
import NoteEditor from '../components/AgendaNoteEditor'

/**
 *
 */

const NoteText = ({ label, text }) => (
  <div>
    <b>{label}</b>
    <div style={{marginLeft: 10, borderLeft: "1px solid #999", paddingLeft: 2}}>
      <ReactMarkdown source={linkifyMarkdown(text)} />
    </div>
  </div>
)

const NoteItem = props => {
  const {item, routeId, i} = props
  return (
    <ItemTemplate
      {...props}
      compact={false /* no way to show notes compact */ }
      disableTitleLine
      description={
        <div>
          { item.internalText && <NoteText text={item.internalText} label="Nota interna" /> }
          { item.text && <NoteText text={item.text} label="Nota para cliente" /> }
          { !item.internalText && !item.text && <b>Nota vacía</b> }
        </div>
      }
      modal={
        () => (
          <NoteEditor
            item={item}
            onChange={(k, v) => props.editItem( routeId,  i, k, v)}
            onClose={() => props.onEndEdit()}
          />
        )
      }
    />
  )
}

export default NoteItem
